import { NavigateAction, RequireLogin } from '../actions';

export function kratosErrorHandler({
  error,
  redirect,
}: {
  error: {
    response: { data: { redirect_browser_to?: string; error?: { id: string } } };
  };
  redirect?: string;
}) {
  switch (error.response.data.error?.id) {
    case 'session_aal2_required':
      return NavigateAction({
        path: ['/', 'auth'],
        query: { aal: 'aal2' },
        reason: 'session_aal2_required',
        extras: {
          replaceUrl: true,
        },
      });
    case 'session_refresh_required':
      return RequireLogin({
        refresh: true,
        postLoginRoute: redirect,
      });
    case 'browser_location_change_required':
      console.log(error.response.data.redirect_browser_to);
      if (error.response.data.redirect_browser_to.includes('login/browser?aal=aal2')) {
        return NavigateAction({
          path: ['/', 'auth'],
          query: { aal: 'aal2' },
          reason: 'browser_location_change_required',
          extras: {
            replaceUrl: true,
          },
        });
      } else {
        window.location = error.response.data.redirect_browser_to as any;
      }
  }
}
